import { FC } from "react";

export type Props = {};

export const EmbedTagPage: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = () => {
  return <div>EmbedTagPage</div>;
};
